import styled from "styled-components";
import { Col, Row } from "reactstrap";

export const fieldHorizontalPadding = 16;

export const SpacedRow = styled(Row)`
  margin: 0 -4px;
`;

export const SpacedCol = styled(Col)`
  padding: 0 4px;
`;
